import firebase from 'firebase';


let firebaseConfig = {
    apiKey: "AIzaSyDLw5f9JfToxC3mUB3k-WrLrmv6mj6YHso",
    authDomain: "gaziantep-digiturk.firebaseapp.com",
    databaseURL: "https://gaziantep-digiturk.firebaseio.com",
    projectId: "gaziantep-digiturk",
    storageBucket: "gaziantep-digiturk.appspot.com",
    messagingSenderId: "656470007253",
    appId: "1:656470007253:web:4ab97d89c6d84181c2315c",
    measurementId: "G-0NHNCECGJZ"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();


  export default firebase;